/** Wrap-around index math for the photo lightbox (v1 lbNav). Kept pure so the
 * gallery's one piece of real logic — cycling past either end — is unit-tested
 * without a DOM harness. */
export function wrapIndex(cur: number, delta: number, len: number): number {
  if (len <= 0) return 0;
  return ((cur + delta) % len + len) % len;
}
